const checkIfLocationEditDisabled = ({
  isTaskCurationDone,
  isTaskQaDone,
  isCurationDone,
  isQaDone,
  isQcDone,
}) => {
  if (isTaskCurationDone && !isTaskQaDone) {
    return isQaDone
  }
  if (!isTaskCurationDone) {
    return isCurationDone
  }
  return isQcDone
}

export default checkIfLocationEditDisabled
